<template lang="html">
  <div id="loading" class="loading">

    <div class="">
      <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  w-full">
        <div class="text-4xl text-red-700 text-center w-full animate-pulse">
          LOADING <span v-if="progress && progress>=0">{{progress}}%</span>
        </div>
      </div>
      <!-- <div class="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2  w-full">
        <div class="text-7xl text-red-700 text-center w-full">
          GOSHKA MACUGA
        </div>
      </div>
      <div class="absolute bottom-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2  w-full">
        <div class="text-2xl text-red-700 text-center w-full">
          IN COLLABORATION WITH HATO
        </div>
      </div> -->
      <div class="absolute bottom-0 inset-x-0">
        <a class="text-sm text-white text-opacity-40 text-center w-full block mx-auto p-2 " href="https://hato.co" target="_blank">Design and build by HATO</a>
      </div>

    </div>

  </div>
</template>

<script>
// import {contents} from '@/common/content.js'
export default {
  // computed: {
  //   contents: ()=> contents
  // },
  computed: {
    progress () {
      let p = Math.round(+this.$store.state.loadingProgress) || this.$store.state.loadingProgress
      if (isNaN(p)) {
        return -1
      } else {
        return p
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  @apply w-full h-full  relative;
}
</style>
